// src/api.js (JavaScript, ללא טיפוסים)
const base = "https://blue-parking-invite.bluept.dev";

export async function getJSON(path, params) {
  const url = new URL(path, base);
  if (params) {
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, String(v)));
  }
  const r = await fetch(url.toString(), { headers: { Accept: "application/json" } });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function postJSON(path, body) {
  const r = await fetch(new URL(path, base), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body ?? {})
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
